export const CART_ROUTING = [
    {
        path: '/cart',
        name: 'cart',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Giỏ hàng', pathName: 'cart', icon: 'fa fa-cart-arrow-down' },
        ] },
        component: () => import('./Cart.vue'),
        redirect: { name: 'cart-index' },
        children: [
            {
                path: '/gio-hang.html',
                name: 'cart-index',
                component: () => import('./components/main-cart/MainCart.vue'),
            },
            {
                path: '/cart/xac-nhan-don.html',
                name: 'cart-confirm-cart',
                props: true,
                meta: {
                    breadcrumb: [
                        { name: 'Xác nhận giỏ hàng', pathName: 'cart-confirm-cart', icon: 'fa fa-cart-arrow-down' },
                ] },
                component: () => import('./components/confirm-cart/ConfirmCart.vue'),
            },
        ],
    },
];
